import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowInbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowInbox"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3V12.0858L15.5 9.58579L16.9142 11L12 15.9142L7.08579 11L8.5 9.58579L11 12.0858V3H13ZM5 14V19H19V14H21V21H3V14H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowInbox;
